export const checkRoleUser = ({ roles = [] } = {}) => roles.includes('USER') && !roles.includes('GUEST');
